<template>
  <b-modal id="edit-access-rule" ref="edit-access-rule" title="Editing Access Rules" @ok="editAccessRule($event)" @hidden="resetModals"
           ok-title="Edit" ok-variant="success" :ok-disabled="disableOkButton">
    <b-alert v-if="accessRuleError" show variant="danger">
      {{ accessRuleError }}
    </b-alert>
    <b-form>
      <b-form-group label="Please select a rule type" v-slot="{ ariaDescribedby }"
                    description="'Domain' grants access to all users with the specified email domain. 'User' only grants access to a specific user.">
        <b-form-radio-group
            id="radio-group-1"
            v-model="accessRuleGroup.rule_type"
            :options="ruleTypeOptions"
            :aria-describedby="ariaDescribedby"
            name="radio-options-rule-type"
        ></b-form-radio-group>
      </b-form-group>
      <b-form-group :label="newAccessRuleEmailLabel" label-for="access-rule-email">
        <b-form-input
            v-model="accessRuleGroup.email"
            :placeholder="newAccessRuleEmailHint"
            id="access-rule-email"
        />
      </b-form-group>
      <b-form-group
          label="Grant access"
          label-for="access-rules"
      >
        <div v-for="(access_rule, index) in accessRuleGroup.access_rules" :key="'access-rule-' + index">
          <div v-if="access_rule.access_machine_serial !== null || access_rule.access_machine_dealer !== null" class="d-flex align-items-center mb-2">
            <b-form-input
                v-model="access_rule.access_machine_serial"
                :placeholder="`Machine Serial`"
                list="machineSerialListId"
                class="mr-2"
                v-if="access_rule.access_machine_serial !== null"
            />
            <b-form-input
                v-model="access_rule.access_machine_dealer"
                :placeholder="`Dealer`"
                list="dealerListId"
                class="mr-2"
                v-if="access_rule.access_machine_dealer !== null"
            />
            <b-button
                variant="danger"
                @click="removeAccessRule(index)"
            >
              Remove
            </b-button>
          </div>
        </div>

        <datalist id="dealerListId">
          <option v-for="dealer in dealerList" :key="dealer">{{ dealer }}</option>
        </datalist>
        <datalist id="machineSerialListId">
          <option v-for="serial in machineSerials" :key="serial">{{ serial }}</option>
        </datalist>
      </b-form-group>
      <b-button variant="primary" size="sm" @click="addDealer">
        <font-awesome-icon icon="plus"/>
        Access by Dealer
      </b-button>
      <b-button variant="primary" size="sm" @click="addSerial" class="ml-2">
        <font-awesome-icon icon="plus"/>
        Access by Machine
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'AccessRulesModalDelete',
  data () {
    return {
      accessRuleError: null,
      accessRuleGroup: {
        'email': '',
        'rule_type': 'domain',
        'access_rules': [],
      },
      ruleTypeOptions: [
        { text: 'Domain', value: 'domain' },
        { text: 'User', value: 'user' },
      ],
      accessType: '',
    }
  },
  created () {
    this.$store.dispatch('loadDealers')
    this.$store.dispatch('loadMachineSerials')
  },
  computed: {
    ...mapGetters(['getDealers', 'getMachineSerials']),
    machineSerials () {
      return this.getMachineSerials
    },
    dealerList () {
      return this.getDealers?.map(dealer => dealer.name)
    },
    disableOkButton () {
      return !this.accessRuleGroup.email
    },
    newAccessRuleEmailLabel () {
      if (this.accessRuleGroup.rule_type === 'domain') {
        return 'Email Domain'
      } else { // this.accessRuleGroup.rule_type === 'user'
        return 'Email Address'
      }
    },
    newAccessRuleEmailHint () {
      if (this.accessRuleGroup.rule_type === 'domain') {
        return 'Enter an access-rule email domain (eg. metso.com)'
      } else { // this.accessRuleGroup.rule_type === 'user'
        return 'Enter an access-rule email (eg. user@metso.com)'
      }
    },
  },
  methods: {
    resetModals () {
      this.accessRuleError = null
      this.accessType = ''
      this.accessRuleGroup = {
        'email': '',
        'rule_type': 'domain',
        'access_rules': [],
      }
    },
    show (data) {
      this.accessRuleGroup = JSON.parse(JSON.stringify(data))
      this.$refs['edit-access-rule'].show()
    },
    async editAccessRule (event) {
      event.preventDefault()
      try {
        await this.$store.dispatch('editAccessRule', this.accessRuleGroup)
        this.$refs['edit-access-rule'].hide()
        this.accessRuleError = null
      } catch (error) {
        this.accessRuleError = 'Failed editing access rules. ' + error
      }
    },
    addDealer () {
      this.accessRuleGroup.access_rules.push({
        'access_machine_dealer': '',
        'access_machine_serial': null,
      })
    },
    addSerial () {
      this.accessRuleGroup.access_rules.push({
        'access_machine_serial': '',
        'access_machine_dealer': null,
      })
    },
    removeAccessRule (index) {
      const access_rule = this.accessRuleGroup.access_rules[index]
      if (access_rule.uuid) {
        access_rule.access_machine_serial = null
        access_rule.access_machine_dealer = null
      } else {
        this.accessRuleGroup.access_rules.splice(index, 1)
      }
    }
  }
}
</script>

<style lang="scss">
</style>
